import React, { useState } from "react";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";

interface Props {
  title?: string;
  message?: string;
  onTapOk: () => Promise<void> | void;
  onTapCancel: () => void;
}

export const DisconnectKCloudConfirmModal = ({ 
  title = "確認", 
  message = "サービス連携を解除しますか？", 
  onTapOk, 
  onTapCancel 
}: Props) => {
  const [isProcessing, setIsProcessing] = useState(false);

  // OKボタン押下時
  const handleOk = async () => {
    setIsProcessing(true);
    try {
      await onTapOk();
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <BasePageModal
      title={title}
      className="md-confirm" // 必要に応じてCSSクラスを調整
      handleClose={onTapCancel}
    >
      <div className="confirm-content">
        <p style={{ margin: "2rem 0", textAlign: "center", lineHeight: "1.6" }}>
          {message}
        </p>

        <nav className="btn-area-row" style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
          <BaseRoundButton
            buttonText="キャンセル"
            className="btn-cancel"
            onClick={onTapCancel}
          />
          <BaseRoundButton
            buttonText={isProcessing ? "処理中..." : "解除する"}
            onClick={handleOk}
          />
        </nav>
      </div>
    </BasePageModal>
  );
};

